module.exports = __webpack_public_path__ + "static/artboard_3-823ddb36a88a38afd944746fc8ab90b6.svg";